module.exports = __webpack_public_path__ + "static/media/4get.45f26d9e.svg";